import * as React from "react";

import { CustomQuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { useQuestionnaireContainerForSection } from "@teamprevent/common/questionnaires";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { FilesQuestion } from "@teamprevent/common/questionnaires/components/questions/FilesQuestion";
import { acceptableExtensions } from "@teamprevent/common/acceptableExtensions";

import { FileAnswer } from "@teamprevent/common/questionnaires/model";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

interface Props {
    questionConfigs: CustomQuestionConfig[];
    fileUploadApi: string;
    onDeleteFile?: (fileId: string, fileName: string, ohCaseDocumentId?: string) => Promise<void>;
    getDownloadLink?: (fileAnswer: FileAnswer) => string;
}

export const HealthSurveillanceConsultationOtherSection: React.FunctionComponent<Props> = (props: Props) => {
    const { readonly } = useQuestionnaireContainerForSection(sections.Other.id);

    return (
        <ContextAwareProgressBarQuestionnaireSection
            {...props}
            {...sections.Other}
        >
            <TextQuestion
                readonly={readonly}
                multiline
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.OtherNotes)}
            />
            <FilesQuestion
                api={props.fileUploadApi}
                readonly={readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.OtherAttachments)}
                getDownloadLink={props.getDownloadLink}
                onDeleteFile={props.onDeleteFile}
                acceptExtensions={acceptableExtensions}
            />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
